import React from 'react'
import { DataTable } from './CandidateActionsRequired/DataTable'

const CandidateActions = () => {
  return (
    <div className="space-y-4">
      <DataTable />
    </div>
  )
}
export default CandidateActions
